import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Package, Rocket, BarChart3 } from 'lucide-react';
import { cn } from '../lib/utils';
import { useLanguage } from '../contexts/LanguageContext';

const bottomNavItems = {
  fr: [
    { path: '/', icon: Home, label: 'Synthèse', partie: 1 },
    { path: '/produit', icon: Package, label: 'Techno', partie: 2 },
    { path: '/plan-execution', icon: Rocket, label: 'Exécution', partie: 3 },
    { path: '/resume-executif', icon: BarChart3, label: 'Prévisions', partie: 4 }
  ],
  en: [
    { path: '/', icon: Home, label: 'Overview', partie: 1 },
    { path: '/produit', icon: Package, label: 'Tech', partie: 2 },
    { path: '/plan-execution', icon: Rocket, label: 'Execution', partie: 3 },
    { path: '/resume-executif', icon: BarChart3, label: 'Forecast', partie: 4 }
  ]
};

export default function BottomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const navItems = bottomNavItems[language];

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Remove focus/active state after click
    setTimeout(() => document.activeElement?.blur(), 100);
  };

  // Determine which partie the current page belongs to
  const getCurrentPartie = () => {
    const path = location.pathname;
    if (path === '/' || path === '/marche' || path === '/vision') return 1;
    if (path === '/produit' || path === '/propriete-intellectuelle' || path === '/paiements') return 2;
    if (path === '/plan-execution' || path === '/gtm' || path === '/roadmap') return 3;
    return 4; // PARTIE IV (all financial pages)
  };

  const currentPartie = getCurrentPartie();

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-t border-lime-500/30 pb-safe">
      <div className="flex items-center justify-around px-2 py-3">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentPartie === item.partie;
          
          return (
            <button
              key={item.path}
              onClick={() => handleNavigate(item.path)}
              className={cn(
                "flex flex-col items-center gap-1 px-3 py-2 rounded-lg transition-all duration-200",
                isActive
                  ? "bg-lime-500/20 text-lime-400"
                  : "text-gray-400 hover:text-lime-400 hover:bg-lime-500/10"
              )}
            >
              <Icon className={cn(
                "h-5 w-5",
                isActive && "drop-shadow-[0_0_8px_rgba(168,213,48,0.8)]"
              )} />
              <span className="text-xs font-medium">
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
